'use client';
const PluginsStatusTracker = (options)=>{
    const { bus } = options;
    const supervisor = {
        track,
        isTracked,
        untrack,
        activate,
        isActive
    };
    const statuses = new Map();
    function track({ id }) {
        bus.emit('plugin-tracked', id);
        return statuses.set(id, false);
    }
    function activate({ id }) {
        bus.emit('plugin-activated', id);
        return statuses.set(id, true);
    }
    function isTracked({ id }) {
        return statuses.has(id);
    }
    function isActive({ id }) {
        return statuses.get(id);
    }
    function untrack({ id }) {
        statuses.delete(id);
        bus.emit('plugin-untracked', id);
    }
    return supervisor;
};

export { PluginsStatusTracker };
//# sourceMappingURL=PluginsStatusTracker.js.map
